import Cohorts from './Cohorts';
export default Cohorts;
